import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '@vr/lib/styles/theme';

const Container = styled.label`
  input {
    display: none;
  }

  padding-left: 56px;
  position: relative;
  cursor: pointer;

  &::before {
    content: ' ';
    position: absolute;
    left: 0;
    width: 40px;
    height: 22px;
    box-sizing: border-box;
    border: 2px solid ${theme.colors.white};
    border-radius: 40px;
  }
  &::after {
    content: ' ';
    position: absolute;
    left: 4px;
    top: 4px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: ${theme.colors.white};
    opacity: ${({ checked }) => (checked ? 1 : 0.7)};
    transform: translateX(${({ checked }) => (checked ? '18px' : '0px')});
    transition: 0.3s;
  }

  span {
    font-weight: 600;
    color: ${theme.colors.white};
  }
`;

const Component = ({
  style = {},
  checked,
  onChange,
  label,
  ref,
  name,
  className,
}) => {
  const [isChecked, setIsChecked] = useState(checked);
  const conditionCheck = useMemo(
    () => (typeof checked === 'boolean' ? checked : isChecked),
    [isChecked, checked],
  );
  return (
    <Container
      style={style}
      className={className}
      checked={conditionCheck}
      htmlFor={name}
    >
      <input
        type="checkbox"
        ref={ref}
        name={name}
        id={name}
        checked={conditionCheck}
        onChange={e => {
          if (onChange) {
            onChange(e.target.checked);
          }
          setIsChecked(e.target.checked);
        }}
      />
      {label && <span>{label}</span>}
    </Container>
  );
};

const { object, bool, func, string } = PropTypes;

Component.propTypes = {
  style: object,
  checked: bool,
  onChange: func,
  label: string,
  ref: func,
  name: string.isRequired,
  className: string,
};

export default Component;
